import {
  AdminDollarInput,
  AdminRadioInput,
  Button,
  Div,
  ErrorToast,
  Modal,
  P,
  PropsModal,
  Separator,
} from '@vgrubs/components';
import { EarningPlanEntity } from 'components/src/types/location.types';
import { Dispatch, SetStateAction, useState } from 'react';

const earningPlansOptions = {
  YEAR_PLAN: 1,
  LIFETIME_PLAN: 2,
};

function findObjectWithHighestYear(earningPlans) {
  if (earningPlans.length === 0) {
    return null; // Return null if the array is empty
  }

  let maxYearObject = earningPlans[0]; // Initialize with the first object
  for (let i = 1; i < earningPlans.length; i++) {
    if (earningPlans[i].year > maxYearObject.year) {
      maxYearObject = earningPlans[i]; // Update maxYearObject if a higher year is found
    }
  }
  return maxYearObject;
}

export const AddEarningPlan = ({
  modalIsOpen,
  closeModal,
  earningPlans,
  setEarningPlans,
  onSavePlans,
}: PropsModal & {
  earningPlans: Partial<EarningPlanEntity>[];
  setEarningPlans: Dispatch<SetStateAction<Partial<EarningPlanEntity>[]>>;
  onSavePlans: (plans: Partial<EarningPlanEntity>[]) => void;
  modalIsOpen: boolean;
}) => {
  const [selectedPlan, setSelectedPlan] = useState(
    earningPlansOptions.YEAR_PLAN
  );
  const [amount, setAmount] = useState(0);

  const addInState = () => {
    if (!amount) {
      ErrorToast('The amount must be greater than zero');
      return;
    }

    const newPlan =
      selectedPlan === earningPlansOptions.LIFETIME_PLAN
        ? { year: null, amount }
        : {
            year: (findObjectWithHighestYear(earningPlans)?.year ?? 0) + 1,
            amount,
          };

    const newPlans = [...earningPlans, newPlan];
    setEarningPlans(newPlans);
    onSavePlans(newPlans);

    closeModal?.();
    setAmount(0);
    setSelectedPlan(earningPlansOptions.YEAR_PLAN);
  };

  function hasLifeTimePlan() {
    for (let i = 0; i < earningPlans.length; i++) {
      if (earningPlans[i].year === null) {
        return true; // Found an object with null year
      }
    }
    return false; // No object with null year found
  }

  return (
    <Modal
      isOpen={modalIsOpen}
      closeModal={closeModal}
      logo={false}
      header="Add Earning Plan"
      zIndex={110}
    >
      <Separator />
      <AdminRadioInput
        label="Add Year Plan"
        checked={selectedPlan === earningPlansOptions.YEAR_PLAN}
        onClick={() => setSelectedPlan(earningPlansOptions.YEAR_PLAN)}
      />
      <Separator />
      {!hasLifeTimePlan() && (
        <>
          <AdminRadioInput
            label="Add Lifetime Plan"
            checked={selectedPlan === earningPlansOptions.LIFETIME_PLAN}
            onClick={() => setSelectedPlan(earningPlansOptions.LIFETIME_PLAN)}
          />
          <Separator />
        </>
      )}

      <Div $flex $alignCenter $between $m="16px 0">
        <P $m="0">Add Amount</P>
        <Div $maxWidth="120px">
          <AdminDollarInput
            prefix="$"
            value={amount / 100}
            onChange={(_, value) => setAmount(value * 100)}
          />
        </Div>
      </Div>

      <Button $selected $w="100%" $mt="20" onClick={addInState}>
        Add
      </Button>
    </Modal>
  );
};
